import { Selector } from '@ngxs/store';
import { ViewState, ViewStateModel } from './view.state';

export class ViewSelectors {
  @Selector([ViewState])
  public static getState(state: ViewStateModel): ViewStateModel {
    return state;
  }

  @Selector([ViewState])
  public static isMenuOpen(state: ViewStateModel): boolean {
    return state.isMenuOpen;
  }
}
